var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.975 2.16666H15.5583C16.3828 2.16666 16.9302 2.38317 17.2735 2.72646C17.6168 3.06975 17.8333 3.61719 17.8333 4.44166V6.02499C17.8333 6.84946 17.6168 7.39689 17.2735 7.74019C16.9302 8.08348 16.3828 8.29999 15.5583 8.29999H13.975C13.1505 8.29999 12.603 8.08348 12.2598 7.74019C11.9165 7.39689 11.7 6.84946 11.7 6.02499V4.44166C11.7 3.61719 11.9165 3.06975 12.2598 2.72646C12.603 2.38317 13.1505 2.16666 13.975 2.16666Z",
    stroke: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30009 13.9727H8.30008V13.975V15.5583C8.30008 16.3828 8.08357 16.9303 7.74028 17.2735C7.39699 17.6168 6.84955 17.8333 6.02508 17.8333H4.44175C3.61729 17.8333 3.07013 17.6169 2.72695 17.2729C2.38357 16.9288 2.16675 16.3792 2.16675 15.55V13.9667C2.16675 13.1422 2.38324 12.5951 2.7272 12.2519C3.07134 11.9085 3.62086 11.6917 4.45008 11.6917H6.03341C6.85806 11.6917 7.40483 11.9083 7.74678 12.2517C8.08871 12.5952 8.30387 13.1439 8.30009 13.9727Z",
    stroke: "#7D7D7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31675 5.24166C8.31675 6.93993 6.94002 8.31666 5.24175 8.31666C3.54347 8.31666 2.16675 6.93993 2.16675 5.24166C2.16675 3.54338 3.54347 2.16666 5.24175 2.16666C6.94002 2.16666 8.31675 3.54338 8.31675 5.24166Z",
    stroke: "#7D7D7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 14.7583C17.8333 16.4566 16.4566 17.8333 14.7583 17.8333C13.0601 17.8333 11.6833 16.4566 11.6833 14.7583C11.6833 13.06 13.0601 11.6833 14.7583 11.6833C16.4566 11.6833 17.8333 13.06 17.8333 14.7583Z",
    stroke: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory2);
export default __webpack_public_path__ + "static/media/category-2.8a369c32e400937f2d58a837dd866820.svg";
export { ForwardRef as ReactComponent };